import { loadTranslations } from 'react-redux-i18n'
import { store } from '../../../../app/store'

store.dispatch(
  loadTranslations({
    en: {
      ...store.getState().i18n.translations.en,
      common: {
        ...store.getState().i18n.translations.en.common,
        panel: {
          ADD_NEW_PANEL: 'Add new panel',
        },
      },
    },
    vi: {
      ...store.getState().i18n.translations.vi,
      common: {
        ...store.getState().i18n.translations.vi.common,
        panel: {
          ADD_NEW_PANEL: 'Thêm tính năng',
        },
      },
    },
  }),
)
